"use strict";
exports.__esModule = true;
var ACTION_TYPES = {
    SET_DOMAIN_ID: 'SET_DOMAIN_ID',
    SET_DOMAIN_NAME: 'SET_DOMAIN_NAME',
    SET_DOMAIN_DATA: 'SET_DOMAIN_DATA',
    SET_AGENTS_LIST: 'SET_AGENTS_LIST',
    SET_CURRENT_AGENT_ID: 'SET_CURRENT_AGENT_ID',
    SET_CURRENT_AGENT_DATA: 'SET_CURRENT_AGENT_DATA',
    SET_ACTIONS: 'SET_ACTIONS',
    SET_CURRENT_ACTION_DATA: 'SET_CURRENT_ACTION_DATA',
    SET_ENV_VARIABLES: 'SET_ENV_VARIABLES',
    SET_ERRORS: 'SET_ERRORS',
    SET_AVAILABLE_MODELS: 'SET_AVAILABLE_MODELS',
};
exports["default"] = ACTION_TYPES;
